<template>
  <div>
    <header class="masthead">
      <div class="inner d-flex px-3 py-3">
        <div class="brand align-items-center animate__animated animate__slideInDown" v-if="showOrg">
          <img v-if="organization.logo" :src="getOrganizationLogo(organization.id)" alt="">
          <img v-else src="@/assets/images/logo/VTS_Perform_White.svg" alt="">
        </div>
        <div
          class="user-info d-flex ml-auto align-items-center cursor-hand"
          @click.stop="showProfileAction">
          <div class="user-info__image rounded-circle position-relative">
            <img
              v-if="currentUser.avatarURL"
              class="cover-fit border-pad w-50px h-50px"
              :src="userAvatar"
              alt="">
            <div v-else class="avatar-placeholder">
              {{currentUser.initials}}
            </div>
          </div>
          <div class="user-info_body d-none d-md-block display-h4 pl-4" v-if="showName">
            <div class="body__full-name">
              <span> {{$t('profile.hello')}} </span>
              <span class="font-weight-bold">{{ currentUser.firstName }} </span>
            </div>
            <div class="body__company" v-if="showOrg">
              <span class="font-weight-bold mr-1"> {{ organization.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </header>
    <ProfileCanvas :class="{'offcanvas-on': showProfile}" @close="closeProfile"/>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import ProfileCanvas from '@/components/canvas/ProfileCanvas.vue';
import HelperMixin from '@/mixins/helperMixin';

export default {
  name: 'TheHeader',
  mixins: [HelperMixin],
  components: {
    ProfileCanvas,
  },
  computed: {
    ...mapGetters(['currentUser', 'userAvatar', 'portal', 'organization', 'organizations']),
  },
  props: {
    showOrg: {
      default: true,
      type: Boolean,
    },
    showName: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      showProfile: false,
    };
  },
  methods: {
    closeProfile() {
      this.showProfile = false;
    },
    showProfileAction() {
      this.showProfile = true;
    },
  },
};
</script>
